"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = exports.Bullet = exports.StepWrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _wizard = require("./wizard.style");

const StepWrapper = _stylitas.styled.div`
  ${_wizard.wizardStep};
`;
exports.StepWrapper = StepWrapper;
const Bullet = _stylitas.styled.div`
  ${_wizard.wizardBullet};
  ${_wizard.wizardBulletWithIcon};
  ${_wizard.wizardBulletSmall};
  ${_wizard.wizardBulletRegular};
  ${_wizard.wizardActive};
  ${_wizard.wizardSuccess};
  ${_wizard.wizardDisabled};
  ${_wizard.wizardBulletLarge};
  ${_wizard.wizardBulletCustom};
  ${_wizard.wizardBulletVertical};
`;
exports.Bullet = Bullet;
const Line = _stylitas.styled.div`
  ${_wizard.wizardLine};
  ${_wizard.wizardActive};
  ${_wizard.wizardSuccess};
  ${_wizard.wizardDisabled};
  ${_wizard.wizardLineVertical};
  ${_wizard.wizardLineCustom};
  ${_wizard.wizardLineLastStep};
`;
exports.Line = Line;